/* v40 (Rijul, 3 Nov), v41 (4 Nov): Curated Sets.
   A set view (the old set page, sections/fl-set.liquid, or a set opened over the home page from sections/fl-sets.liquid)
   keeps its "add the whole set" form in step with the list: chosen option, quantity (never past the stock left)
   and pieces taken out with Remove from set. Thumbnails show a piece on its own in the big picture and jump to its row.
   v41: the home page sets open over the page ("View set", or links like /#set-3), with a day / evening switch on the big photo.
   The adding itself is done by assets/fl-cart.js (forms marked data-fl-set add several pieces in one call). */
(function(){
  function money(cents,fmt){
    var n=(cents||0)/100,f=fmt||'Rs. {{amount}}';
    function g(x,d,ts,ds){var s=x.toFixed(d),p=s.split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,ts);return p[0]+(p[1]?ds+p[1]:'')}
    return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){
      if(k==='amount_no_decimals')return g(n,0,',','.');
      if(k==='amount_with_comma_separator')return g(n,2,'.',',');
      if(k==='amount_no_decimals_with_comma_separator')return g(n,0,'.',',');
      return g(n,2,',','.')});
  }
  function init(root){
    if(root.__flSet)return;root.__flSet=1;
    var fmt=root.getAttribute('data-money'),rows=[].slice.call(root.querySelectorAll('[data-fl-row]'));
    var main=root.querySelector('[data-fl-main]'),cap=root.querySelector('[data-fl-cap]'),slides=root.querySelectorAll('[data-fl-slide]');
    var tot=root.querySelector('[data-fl-tot]'),totn=root.querySelector('[data-fl-totn]'),stickT=root.querySelector('[data-fl-stickt]');
    var allIn=root.querySelector('[data-fl-allinputs]'),allBtn=root.querySelector('[data-fl-allbtn]'),btnText=allBtn?allBtn.textContent:'';
    var whole=root.querySelector('.fl-setd__whole');
    var live=rows.filter(function(r){return r.hasAttribute('data-fl-on')});
    /* v45 (Rijul, 4 Nov): the 7% set saving. While every piece is still in, with its set option and quantity 1,
       the bar adds the set's one bundle product at the set price. Take a piece out or change one and the saving goes;
       put it back and it returns. */
    var bid=root.getAttribute('data-fl-bid'),bp=+root.getAttribute('data-fl-bp')||0,bc=+root.getAttribute('data-fl-bc')||0;
    var bsave=root.getAttribute('data-fl-bsave')||'Save 7%',badd=root.getAttribute('data-fl-badd')||'Add the set';
    var saveNote=root.querySelector('[data-fl-savenote]'),allForm=allBtn&&allBtn.form;
    var start=live.map(function(r){var pr=r.querySelector('[data-fl-pr]'),sel=r.querySelector('[data-fl-var]'),o=sel&&sel.options[sel.selectedIndex];return o?o.value:pr.getAttribute('data-id')});
    function st(r){
      var pr=r.querySelector('[data-fl-pr]'),sel=r.querySelector('[data-fl-var]'),o=sel&&sel.options[sel.selectedIndex];
      var id=o?o.value:pr.getAttribute('data-id'),price=+(o?o.getAttribute('data-price'):pr.getAttribute('data-price'));
      var max=+(o?o.getAttribute('data-max'):pr.getAttribute('data-max'))||1;
      var qn=r.querySelector('[data-fl-qn]'),q=Math.max(1,Math.min(parseInt(qn.textContent,10)||1,max));
      return {id:id,price:price,max:max,q:q,on:r.getAttribute('data-fl-on')==='1'};
    }
    function draw(r){
      var s=st(r),pr=r.querySelector('[data-fl-pr]');
      pr.textContent=money(s.price,fmt);r.querySelector('[data-fl-qn]').textContent=s.q;
      var b=r.querySelectorAll('[data-fl-q]');b[0].disabled=s.q<=1;b[1].disabled=s.q>=s.max;
      var oid=r.querySelector('[data-fl-oid]'),oq=r.querySelector('[data-fl-oq]');if(oid)oid.value=s.id;if(oq)oq.value=s.q;
      var low=r.querySelector('[data-fl-low]');if(low){low.hidden=!(s.max<10);var lf=low.querySelector('[data-fl-left]');if(lf)lf.textContent=s.max}
      r.classList.toggle('is-off',!s.on);
      var rm=r.querySelector('[data-fl-rm]'),off=r.querySelector('[data-fl-offmsg]');if(rm)rm.hidden=!s.on;if(off)off.hidden=s.on;
    }
    function sum(){
      var n=0,pcs=0,t=0,h='';
      live.forEach(function(r){var s=st(r);if(!s.on)return;n++;pcs+=s.q;t+=s.price*s.q;
        h+='<input type="hidden" name="items[][id]" value="'+s.id+'"><input type="hidden" name="items[][quantity]" value="'+s.q+'">'});
      var all=n===live.length;
      var set=!!bid&&all&&live.every(function(r,i){var s=st(r);return s.q===1&&String(s.id)===String(start[i])});
      if(set){
        if(allIn)allIn.innerHTML='<input type="hidden" name="items[][id]" value="'+bid+'"><input type="hidden" name="items[][quantity]" value="1">';
        if(tot)tot.innerHTML='<s class="fl-setp__was">'+money(bc,fmt)+'</s> '+money(bp,fmt);
        if(totn)totn.innerHTML='for the whole set <b class="fl-setc__save">'+bsave+'</b>';
        if(stickT)stickT.innerHTML='<b>The whole set</b> · <s class="fl-setp__was">'+money(bc,fmt)+'</s> <span class="fl-nw">'+money(bp,fmt)+'</span> <b class="fl-setc__save">'+bsave+'</b>';
        if(allBtn){allBtn.disabled=false;allBtn.textContent=badd}
      }else{
        if(allIn)allIn.innerHTML=h;
        if(tot)tot.textContent=money(t,fmt);
        if(totn)totn.textContent=pcs?(all?'for all '+pcs+(pcs===1?' piece':' pieces'):'for '+pcs+(pcs===1?' piece':' pieces')+' you picked'):'Nothing picked yet';
        if(stickT)stickT.innerHTML=pcs?'<b>'+pcs+(pcs===1?' piece':' pieces')+'</b> · '+money(t,fmt):'No pieces picked';
        if(allBtn){allBtn.disabled=!pcs;allBtn.textContent=pcs?(bid?'Add '+pcs+(pcs===1?' piece':' pieces'):btnText+' · '+pcs+(pcs===1?' piece':' pieces')):btnText}
      }
      if(saveNote)saveNote.hidden=set||!bid;
      if(allForm){if(set)allForm.setAttribute('data-fl-bundle','');else allForm.removeAttribute('data-fl-bundle')}
    }
    function show(i){
      [].forEach.call(slides,function(s){var on=s.getAttribute('data-fl-slide')===String(i);s.hidden=!on;s.classList.toggle('is-on',on)});
      [].forEach.call(root.querySelectorAll('.fl-setp__thumbs [data-fl-th]'),function(b){b.setAttribute('aria-pressed',b.getAttribute('data-fl-th')===String(i)?'true':'false')});
      if(cap){var r=rows[i];var nm=r&&r.querySelector('.fl-setp__nm');var sel=r&&r.querySelector('[data-fl-var]');
        cap.textContent=i<0||!nm?cap.getAttribute('data-whole'):nm.textContent+(sel?' · '+sel.options[sel.selectedIndex].text:'')}
      root.classList.toggle('is-piece',i>=0);
    }
    function mode(m){if(!whole)return;whole.setAttribute('data-mode',m);
      [].forEach.call(root.querySelectorAll('[data-fl-mode]'),function(b){b.setAttribute('aria-pressed',b.getAttribute('data-fl-mode')===m?'true':'false')})}
    var wide=window.matchMedia('(min-width: 990px)');
    root.addEventListener('click',function(e){
      var md=e.target.closest('[data-fl-mode]');
      if(md){mode(md.getAttribute('data-fl-mode'));show(-1);return}
      var t=e.target.closest('[data-fl-th]');
      if(t){var i=+t.getAttribute('data-fl-th'),inList=!!t.closest('[data-fl-row]');show(i);
        if(i>=0&&!inList){var r=rows[i];if(r){r.scrollIntoView({behavior:'smooth',block:wide.matches?'nearest':'center'});r.classList.remove('is-flash');void r.offsetWidth;r.classList.add('is-flash')}}
        else if(inList&&!wide.matches&&main){main.scrollIntoView({behavior:'smooth',block:'start'})}
        return}
      var q=e.target.closest('[data-fl-q]');
      if(q){var r=q.closest('[data-fl-row]'),s=st(r),n=s.q+(+q.getAttribute('data-fl-q'));r.querySelector('[data-fl-qn]').textContent=Math.max(1,Math.min(n,s.max));draw(r);sum();return}
      var rm=e.target.closest('[data-fl-rm]'),un=e.target.closest('[data-fl-undo]');
      if(rm||un){var r=(rm||un).closest('[data-fl-row]');r.setAttribute('data-fl-on',un?'1':'0');draw(r);sum();
        var f=r.querySelector(un?'[data-fl-rm]':'[data-fl-undo]');if(f)f.focus({preventScroll:true});return}
    });
    root.addEventListener('change',function(e){var s=e.target.closest('[data-fl-var]');if(!s)return;var r=s.closest('[data-fl-row]');draw(r);sum();
      var on=root.querySelector('.fl-setp__thumbs [aria-pressed="true"]');if(on&&+on.getAttribute('data-fl-th')===rows.indexOf(r))show(rows.indexOf(r))});
    live.forEach(draw);sum();
    root.__flShow=show;root.__flMode=mode;
  }

  /* v41: the set view over the home page */
  var openD=null,opener=null;
  function drawer(n){return document.querySelector('[data-fl-setd="'+n+'"]')}
  function open(n,from){
    var d=drawer(n);if(!d)return false;
    if(openD&&openD!==d)close(true);
    var p=d.querySelector('[data-fl-setp]');init(p);
    d.hidden=false;document.documentElement.classList.add('fl-setd-on');openD=d;opener=from||document.activeElement;
    if(p.__flShow)p.__flShow(-1);if(p.__flMode)p.__flMode(document.documentElement.classList.contains('fl-dark')?'d':'l');
    var sc=d.querySelector('.fl-setd__scroll');if(sc)sc.scrollTop=0;
    requestAnimationFrame(function(){d.classList.add('is-on');p.focus({preventScroll:true})});
    return true;
  }
  function close(keepHash){
    if(!openD)return;var d=openD;openD=null;
    d.classList.remove('is-on');d.hidden=true;document.documentElement.classList.remove('fl-setd-on');
    if(!keepHash&&/^#set-\d+$/.test(location.hash)){try{history.replaceState(null,'',location.pathname+location.search+'#curated-sets')}catch(e){}}
    if(opener&&opener.focus){try{opener.focus({preventScroll:true})}catch(e){}}opener=null;
  }
  function fromHash(){var m=/^#set-(\d+)$/.exec(location.hash);if(m){if(open(m[1]))return true}else if(openD)close(true);return false}
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-fl-open]');
    if(a){e.preventDefault();var n=a.getAttribute('data-fl-open');
      if(location.hash!=='#set-'+n){try{history.pushState(null,'','#set-'+n)}catch(x){location.hash='set-'+n;return}}
      open(n,a);return}
    if(openD&&e.target.closest('[data-fl-close]')){e.preventDefault();close()}
  });
  document.addEventListener('keydown',function(e){
    if(!openD)return;
    if(e.key==='Escape'){close();return}
    if(e.key==='Tab'){var p=openD.querySelector('[data-fl-setp]'),f=[].filter.call(p.querySelectorAll('a[href],button:not([disabled]),select,input:not([type="hidden"]),[tabindex]:not([tabindex="-1"])'),function(x){return x.offsetParent!==null});
      if(!f.length)return;var a=f[0],z=f[f.length-1];
      if(e.shiftKey&&(document.activeElement===a||document.activeElement===p)){e.preventDefault();z.focus()}
      else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus()}}
  });
  window.addEventListener('hashchange',fromHash);
  window.addEventListener('popstate',fromHash);
  function go(){
    [].forEach.call(document.querySelectorAll('[data-fl-setp]'),function(r){if(!r.closest('[data-fl-setd]'))init(r)});
    if(fromHash()){var s=document.getElementById('curated-sets');if(s)s.scrollIntoView({block:'start'})}
  }
  document.readyState!=='loading'?go():document.addEventListener('DOMContentLoaded',go);
})();
